
import { defineStore } from "pinia" //引入pinia

export const useMenuStore = defineStore('childrenMenu', {
  state: () => ({
    // 存储子菜单的数组
    children: [],
    //被选中的子菜单
    selectable: ''
  }),
  persist: true,//持久化
  actions: {
    // 添加单个子菜单
    addChildren(menu) {
      this.children.push(menu);
    },
    // 添加集合
    addAllChildren(menu,selected) {
      this.children = menu;
      this.selectable = selected
    },
    // 移除子菜单
    removeChildren(menuId) {
      this.children = this.children.filter(menu => menu.menuCode !== menuId);
    },
    // 更新子菜单
    updateChildren(updatedMenu) {
      const index = this.children.findIndex(menu => menu.menuCode === updatedMenu.menuCode);
      if (index !== -1) {
        this.children[index] = updatedMenu;
      }
    },
    // 移除所有
    removeAll() {
      this.children = [];
      this.selectable = '';
    },
    // 选中子菜单
    selectTb(key) {
      this.selectable = key;
    },
  }
});

// 用户信息 store
export const useUserStore = defineStore('userInfo', {
  state: () => ({
    menus: [],
    permissions: [],
  }),
  persist: true,
  getters: {
    // 判断是否为业务层用户（COMMON 权限）
    isBizUser: (state) => {
      const perms = state.permissions;
      if (Array.isArray(perms)) {
        return perms.some(p => p.permissionCode === 'COMMON' || p === 'COMMON');
      }
      // 单个对象
      if (perms && typeof perms === 'object') {
        return perms.permissionCode === 'COMMON';
      }
      return false;
    },
    // 是否有某个菜单权限
    hasMenu: (state) => (menuCode) => {
      const m = state.menus;
      if (!Array.isArray(m)) return false;
      return m.some(item => item.menuCode === menuCode);
    },
  },
  actions: {
    setUserInfo({ menus, permissions }) {
      this.menus = menus || [];
      this.permissions = permissions || [];
    },
    clearUserInfo() {
      this.menus = [];
      this.permissions = [];
    },
  }
});
